/**
 * Wo ein Frage-Gang steht — aus der Sicht dessen, der ihn gegangen ist.
 * (08.09.2026)
 *
 * ## Woher das kommt
 *
 * Martin: *„Ich sehe bei ‚Tiefer Frage' immer noch nicht ‚Gelandet'. Bei den
 * anderen, wo ich eigentlich gar nichts gemacht habe, steht ‚Gelandet'. Das
 * verstehe ich nicht. Da habe ich zwei Antworten gegeben."*
 *
 * An seinen Daten nachgezaehlt, und er hat in beide Richtungen recht:
 *
 *     05./06./07.09.   35 Fragen, alle beantwortet   →  kein „gelandet"
 *     30.08.           17 Fragen, KEINE beantwortet  →  alle „gelandet"
 *
 * ## Warum das so kam
 *
 * Die Anzeige las den Zustand der LETZTEN Zeile. Am Ende eines Gangs haengt
 * aber oft eine frisch erzeugte, noch unbeantwortete Frage — und genau die
 * wurde beim Schliessen gelandet. Das Etikett beschrieb also den leeren
 * Nachzuegler, nicht die Arbeit darueber.
 *
 * ## Die Regel hier
 *
 * Ein Gang ist GELANDET, wenn es einen Schlusssatz gibt — die Erkenntnis
 * ist der Beweis, dass er zur Ruhe gekommen ist. Wer geantwortet hat, ist
 * BEANTWORTET. Wo nichts steht, ist UNBEANTWORTET.
 *
 * ## ⚠️⚠️ 22.09.2026 — HIER STAND „AUSGEWICHEN", UND DAS WAR EINE
 * ##    UNTERSTELLUNG.
 *
 * Martin, zu einer Frage an Albert vom 22.07.: *„Wenn sie niemals begonnen
 * hat, beantwortet zu werden, dann ist es nicht ausgiebig beantwortet, oder
 * dann ist es einfach nicht beantwortet."*
 *
 * An der Datenbank nachgezaehlt: von 38 als „ausgewichen" gefuehrten Fragen
 * waren **38** Wurzelfragen ohne Antwort UND ohne Folgefrage — also nie
 * begonnen. Keine einzige echte Ausweichung darunter.
 *
 * Ausweichen heisst: hinsehen und sich abwenden. Das setzt voraus, dass
 * jemand da war. Ob die Frage ueberhaupt gesehen wurde, weiss das System
 * nicht — es gibt keine Spalte dafuer. Wovon es weiss, ist allein, dass
 * nichts geantwortet wurde. Genau das sagt das Etikett jetzt, und nicht
 * mehr.
 *
 * ⚠️ Bewusst am INHALT gemessen, nicht am gespeicherten Zustand: Der
 *    Zustand einer einzelnen Zeile hat sich als unzuverlaessig erwiesen,
 *    der Schlusssatz und die Antworten sind es nicht.
 */

type FadenStand = "gelandet" | "beantwortet" | "unbeantwortet";

interface FadenSchritt {
  answerText?: string | null;
  landungText?: string | null;
}

export function fadenStand(schritte: readonly FadenSchritt[]): FadenStand {
  if (schritte.some((s) => s.landungText?.trim())) return "gelandet";
  if (schritte.some((s) => s.answerText?.trim())) return "beantwortet";
  return "unbeantwortet";
}

/** Was am Faden steht — „beantwortet" ist der Normalfall und bleibt stumm. */
export function fadenEtikett(stand: FadenStand): string | null {
  return stand === "beantwortet" ? null : stand;
}
